import axios from 'axios'
import translate from '../utils/translations'

export default {
  name: 'port',

  ui: {
    model: '[js-port-model]',
    countriesFirst: '[js-port-countries-first]',
    countriesSecond: '[js-port-countries-second]',
    states: '[js-port-states]',
    'radio[]': '[js-port-radio]',
  },

  events: [
    {
      on: 'change',
      target: 'countriesFirst',
      handle(e) {
        // at change
        this.getStatesFromCountry(e.target.value)

        if (this.ui.countriesSecond.customSelect) {
          this.ui.countriesSecond.customSelect.value = e.target.value
          this.ui.countriesSecond.customSelect.disabled = true
        }
      },
    },
  ],

  componentDidMount() {
    if (this.ui.model) {
      this.ui.model.addEventListener('change', (e) => {
        this.getCountriesFromModel(e.target.value, false)
      })

      // at init
      this.getCountriesFromModel(this.ui.model.value, true)
    }

    if (this.props.model) {
      this.getCountriesFromModel(this.props.model, true)
    }

    if (this.ui.radio.length > 0) {
      this.ui.radio.forEach(radio => {
        radio.addEventListener('change', (e) => {
          const container = e.target.closest('[js-form-validation-field-wrapper]')

          if (e.target.value === 'abroad') {
            const message = document.createElement('p')
            message.classList.add('form__error')
            let messages = {
              fr: "Pour vous apporter le meilleur accompagnement possible, nous vous conseillons de contacter le Concessionnaire le plus proche de votre lieu de résidence !",
              en: "To provide you with the best possible support, we recommend that you speak to a dealer in your country, closest to where you live!",
              es: "Para ofrecerle la mejor asistencia posible, le aconsejamos que se ponga en contacto con el distribuidor de su país más cercano a su domicilio."
            }
            message.innerHTML = messages[document.documentElement.lang]
            container.parentNode.insertBefore(message, container.nextElementSibling)
          } else {
            const error = container.parentNode.querySelector('.form__error')

            if (error) {
              error.remove()
            }
          }
        })
      })
    }
  },

  getCountriesFromModel(model, isInit) {
    const formData = new FormData()
    formData.append('lang', document.documentElement.lang)
    formData.append('InternalID', model)
    formData.append('nonce', this.props.nonce1)
    formData.append('action', 'wp_fp_zoho_boarding_pass__get_countries_ajax')

    axios.post(this.props.ajax, formData)
      .then(response => {
        if (response.data.success) {
          this.ui.countriesFirst.customSelect.empty()
          this.ui.countriesSecond.customSelect.empty()

          this.fillCountrySelect(this.ui.countriesFirst, response)
          this.fillCountrySelect(this.ui.countriesSecond, response)

          this.getStatesFromCountry(this.ui.countriesFirst.customSelect.value)

          this.ui.countriesSecond.customSelect.value = this.ui.countriesFirst.customSelect.value
          this.ui.countriesSecond.customSelect.disabled = true
        }
      })
      .catch(e => {
        console.log(e)
      })
  },

  fillCountrySelect(select, response) {
    const placeholder = document.createElement('option')
    placeholder.value = ''
    placeholder.text = translate('FORM_COUNTRY')
    select.customSelect.append(placeholder)
    select.closest('.custom-select').classList.add('has-placeholder')

    response.data.data.forEach(elem => {
      const option = document.createElement('option')
      option.value = elem.InternalID
      option.text = elem.Name

      select.customSelect.append(option)
    })
  },

  getStatesFromCountry(country) {
    const formData = new FormData()
    formData.append('InternalID', country)
    formData.append('nonce', this.props.nonce2)
    formData.append('action', 'wp_fp_zoho_boarding_pass__get_states_ajax')

    axios.post(this.props.ajax, formData)
      .then(response => {
        if (response.data.success) {
          this.ui.states.customSelect.empty()

          if (response.data.data.length > 1) {
            const placeholder = document.createElement('option')
            placeholder.value = ''
            placeholder.text = translate('FORM_STATE')
            this.ui.states.customSelect.append(placeholder)
            this.ui.states.closest('.custom-select').classList.add('has-placeholder')
          }

          response.data.data.forEach(elem => {
            const option = document.createElement('option')
            option.value = elem.InternalID
            option.text = elem.Name

            this.ui.states.customSelect.append(option)
          })
        }
      })
      .catch(e => {
        console.log('error')
      })
  },
}
